import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DatesService } from "@cotecna/dates";
import {
  Field,
  FormComponent,
  FormResult,
  FormReturnType,
  NaturalFormConfig,
  NaturalFormFlavour,
  NaturalFormStyle,
  Section,
} from "@cotecna/dynamic-view-engine";
import moment_ from "moment";
import { eventPropertyNames } from "src/app/inspection/constants/constants";
import { InspectionEvent } from "src/app/inspection/model/inspection-event";

import { EVENT_FIELDS, EVENT_SECTIONS } from "./event-form";
const moment = moment_;

@Component({
  selector: "im-event-dialog",
  templateUrl: "./event-dialog.component.html",
  styleUrls: ["./event-dialog.component.scss"],
  standalone: false,
})
export class EventDialogComponent implements OnInit, AfterViewInit {
  private readonly OPTION_PROPERTY_NAME = "option";
  private readonly DATE_PROPERTY_NAME = "date";

  @ViewChild("dynamicForm")
  public form: FormComponent;

  public title: string;
  public sections: Section[];
  public formIsValid: boolean = true;
  private inspectionEvent: InspectionEvent = new InspectionEvent();

  public formConfig: NaturalFormConfig = <NaturalFormConfig>{
    displayMode: NaturalFormStyle.flat,
    flavor: NaturalFormFlavour.informative,
    notifyFieldChange: true,
    returnType: FormReturnType.entity,
  };

  public constructor(
    private dialogRef: MatDialogRef<EventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private datesService: DatesService,
  ) {}

  public ngOnInit(): void {
    const optionField = EVENT_FIELDS.find(
      (field) => field.propertyName === this.OPTION_PROPERTY_NAME,
    );
    if (optionField) {
      //optionField.options = this.dialogData.options;
    }
    const dateField = EVENT_FIELDS.find(
      (field) => field.propertyName === this.DATE_PROPERTY_NAME,
    );
    if (dateField) {
      dateField.value = this.datesService.getLocalMomentFromDateTime(
        new Date().toISOString(),
      );
    }

    this.title = this.dialogData.title;
    this.sections = JSON.parse(JSON.stringify(EVENT_SECTIONS));

    if (this.dialogData?.inspectionEvent) {
      for (const section of this.sections) {
        for (const field of section.fields) {
          this.fillField(field, this.dialogData.inspectionEvent);
        }
      }
    }
  }

  public fillField(field: Field, inspectionEvent: any): void {
    switch (field.propertyName) {
      case eventPropertyNames.startDate:
        field.value = inspectionEvent.startDate;
        break;
      case eventPropertyNames.endDate:
        field.value = inspectionEvent.endDate;
        break;
      case eventPropertyNames.time:
        field.value = inspectionEvent.time;
        break;
      case eventPropertyNames.option:
        field.value = inspectionEvent.optionId;
        break;
      case eventPropertyNames.name:
        field.value = inspectionEvent.name;
        break;
      case eventPropertyNames.item:
        field.value = inspectionEvent.itemId;
        break;
      case eventPropertyNames.printInReport:
        field.value = inspectionEvent.printinreport;
        break;
    }
  }

  public ngAfterViewInit(): void {
    this.form.formSubmitted?.subscribe((result: FormResult) => {
      this.inspectionEvent.optionId = result.data.option;
      this.inspectionEvent.name = result.data.name;
      this.inspectionEvent.startDate = moment(result.data.startDate)
        .utc()
        .toDate();
      this.inspectionEvent.endDate = moment(result.data.endDate).utc().toDate();
      this.inspectionEvent.itemId = result.data.item;
      this.inspectionEvent.printInReport = result.data.printInReport;
    });
  }

  public edit(): void {
    this.form.isValid()
      ? this.dialogRef.close({ inspectionEvent: this.inspectionEvent })
      : (this.formIsValid = false);
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }
}
